import React from 'react';

import type { Icon } from '@rover/icons';
import type { ThemeTextColor, ThemeTextSizes } from '@rover/kibble/styles/themeTypes';

export enum Size {
  Small,
  Default,
  Large,
}
export type Props = {
  title: string;
  subtitle?: string;
  subtitleTextColor?: ThemeTextColor;
  graphic: string | Icon;
  size?: Size;
  rounded?: boolean;
  textSize?: ThemeTextSizes;
  children?: React.ReactNode | string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  href?: string;
  ariaLabel?: string;
  role?: React.AriaRole;
  dataTestId?: string;
};

type SizeStyle = {
  width: number;
  height: number;
};
const SMALL_STYLES: SizeStyle = {
  width: 32,
  height: 32,
};
const DEFAULT_STYLES: SizeStyle = {
  width: 48,
  height: 48,
};
const LARGE_STYLES: SizeStyle = {
  width: 64,
  height: 64,
};
const SIZE_STYLE_MAP = new Map<Size, SizeStyle>([
  [Size.Small, SMALL_STYLES],
  [Size.Default, DEFAULT_STYLES],
  [Size.Large, LARGE_STYLES],
]);

export const getSizeStyles = (size: Size): SizeStyle => {
  return SIZE_STYLE_MAP.get(size) || DEFAULT_STYLES;
};
